/*
*   List of Action IDs that should be passed from accreditation.reducer.js to improvement.reducer.js
 */

export const IDS = {
    // module
    rcoImprovement: 'rcoImprovement',

    // components:
    accreditationImprovementList:       'accreditationImprovementList',
    accreditationImprovementDetails:    'accreditationImprovementDetails',
    accreditationImprovementAdd:        'accreditationImprovementAdd',

    // paths:
    improvementActionsGrid:             'improvementActionsGrid',
    improvementAction:                  'improvementAction',
    improvementStep:                    'improvementStep',
    improvementStepsGrid:               'improvementStepsGrid',
    rcoEvidenceGroupDocumentsGrid:      'rcoEvidenceGroupDocumentsGrid',
    improvementActionAdd:               'improvementActionAdd',
    assigneeCandidates:                 'assigneeCandidates',

    step:                               'step',
    stepDocument:                       'stepDocument',
    stepAssigneeCandidates:             'stepAssigneeCandidates',
    stepStatusOptions:                  'stepStatusOptions',
    stepStatusOptionsForAssigned:       'stepStatusOptionsForAssigned',
    stepStatusOptionsForSubmitted:      'stepStatusOptionsForSubmitted',
    stepStatusOptionsForApproved:       'stepStatusOptionsForApproved',

    // tab states:
    app_accreditation_scheme_improvement:          'app.accreditation.scheme.improvement',
    app_accreditation_scheme_improvement_list:     'app.accreditation.scheme.improvement.list',
    app_accreditation_scheme_improvement_action:   'app.accreditation.scheme.improvement.action',
    app_accreditation_scheme_improvement_action_plan: 'app.accreditation.scheme.improvement.action-plan',
    app_accreditation_scheme_improvement_step:     'app.accreditation.scheme.improvement.step',
    app_accreditation_scheme_improvement_add_action: 'app.accreditation.scheme.improvement.add-action',

    // public tab states
    // public_accreditation_scheme_improvement:       'public.accreditation.scheme.improvement',
};
